import PageTitleIcon from "../UI/PageTitleIcon";
import React, { useState } from "react";
import { ColumnTitle, STituloDivider, STituloTexto } from "./styles";
import {Row, Container, Button, Col} from "react-bootstrap"
import { useNavigate } from "react-router-dom";
import SelectFixoTotvs from "../SelectFixoTotvs";

function TitlePageTotvs({text, empresa, changeEmpresa, empresaFilial, icon}) {
    const navigate = useNavigate();
    const btnIncluir = (event) => {
        navigate("./Incluir")
    };

    const usuarioPermissao = JSON.parse(localStorage.getItem('permissaoRotina'));
    const options = JSON.parse(localStorage.getItem('empresasOptions'));    
    
    return (
        <Row>
            <Container>
                <Row>
                    <ColumnTitle md='8'>
                        <STituloTexto><PageTitleIcon title={text} icon={icon} /><span>{text}</span></STituloTexto>
                    </ColumnTitle>
                    
                    <Col md='4'>
                        <SelectFixoTotvs 
                            options={options}
                            selectedOptionValue={empresa}
                            isLabel={true} 
                            label="Empresa/Filial" 
                            disabled={empresaFilial}
                            onChange={(e) => changeEmpresa(e)}
                        />
                    </Col>
                </Row>                
            </Container>
            <STituloDivider/>
        </Row>
    )
}

export default TitlePageTotvs;